import styled from 'styled-components';

export default styled.th`
  font-size: 14px;
  line-height: 14px;
`;
